import { render, staticRenderFns } from "./StockCompareDashboardCharts.vue?vue&type=template&id=1a79c71a&"
import script from "./StockCompareDashboardCharts.vue?vue&type=script&lang=js&"
export * from "./StockCompareDashboardCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports